import {getLidarFileNames} from "../../getLidarFileNames";


export const florissantmo_obj_arr_2026 = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/florissant_mo_processed/';
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)
    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', ''));
  return lidar_paths.map((path) => {
    const match = path.match(/\d{8}/);
    let date = '';
if (match) {
  const dateStr = match[0]; // "11082025"

  const month = dateStr.slice(0, 2);
  const day = dateStr.slice(2, 4);
  const year = dateStr.slice(4, 8);

  const readableDate = `${month}/${Number(day)}/${year}`;
  date = readableDate;

}

  
  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/florissant_mo_processed/${path}`,
    name: `Florissant MO - ${path}`,
    description: `Scan of Florissant MO 2026 data`,
    date_uploaded: new Date(date),
    data_identifier: 'florissantmo',
    collector: 'NV5',
projection: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs +type=crs"
  }})
  } catch (error) {
    console.error('Error fetching Florissant MO lidar paths:', error);
    return [];
  }
 
};

